function initEventHandlers() {
    var $videoFeatureBtn = $('.video-play-btn');
    $videoFeatureBtn.on('click', playVideo);
}

function playVideo() {
    var src = $(this).attr('data-video');
    var videoIframeId = 'Video_Iframe_' + Math.random();
    var video = '<div class="iframe-container video-iframe"><iframe id="' + videoIframeId + '" src="' + src + '"frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Lofoten from Above" data-ready="true"></iframe></div>';
    $(this).replaceWith(video);
    stopOtherPlayingVideos(videoIframeId);
}

function stopOtherPlayingVideos(videoIframeId) {
    $('.video-iframe iframe').each(function () {
        if(videoIframeId !== $(this).attr('id')) {
            var src = $(this).attr('src');
            var index = src.lastIndexOf('?autoplay=1');
            if(index > 0) {
                src = src.substring(0, index);
            }
            $(this).attr('src', src);
        }
    });
}

$(function () {
    initEventHandlers();
});
